import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import RenderInputs from "../../../Components/Inputs";
import submitForm from "../../../services/submitForm";
import RenderInputsLXH from "./renderInputs";
import { number } from "echarts";

export default function CreateLenhXuatHang() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);
  const { makeAutoIncreament } = functions;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const [isSubmit, setSubmit] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState({});
  const [resfresh, setRefresh] = useState(0);
  const [dataTable, setDataTables] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      name: "Mã Lệnh Giao Hàng",
      alias: "lenhXuatHangERP",
      type: "text",
      required: true,
    },
    {
      name: "Mã Lệnh Giao Hàng",
      alias: "2MLXH",
      type: "text",
      required: true,
    },
    // {
    //   name: "LXH/LĐĐNB",
    //   alias: "LXH/LĐĐNB",
    //   type: "text",
    // },
    {
      name: "Ngày Xuất",
      alias: "2NXH",
      type: "date",
    },
    {
      name: "Kho Xuất",
      alias: "18MK",
      type: "select",
      table_id: 21719,
      displayFields: ["11MK", "8LK"],
      isApi: "/api/LXH/optionKhoXuat",
      required: true,
      isPK: "11MK",
    },
    {
      name: "Số Lượng Cần Xuất (Tấn)",
      alias: "5SLCXTT",
      type: "float",
    },
    {
      name: "Đơn Vị Phân Phối đến",
      alias: "3MNPP",
      type: "select",
      table_id: 21669,
      displayFields: ["2MNPP"],
      required: true,
      isPK: "2MNPP",
    },
    {
      name: "Kho Đến",
      alias: "2KĐ",
      type: "select",
      table_id: 21719,
      displayFields: ["11MK", "8LK"],
      required: true,
      isPK: "11MK",
    },
    {
      name: "Mã Thành Phẩm",
      alias: "28MSP",
      type: "select",
      table_id: 21692,
      displayFields: ["22MSP", "10TSP"],
      required: true,
      isPK: "22MSP",
      isMulti: true,
      isTable: {
        headers: [
          {
            label: "Số Chuyến",
            value: "delivery_detail_id",
            type: "text",
            styles: {
              textAlign: "center",
            },
          },
          {
            label: "Mã Thành Phẩm",
            value: ["mathanhpham", "tenthanhpham"],
            readOnly: true,
            styles: {
              textAlign: "left",
            },
          },
          {
            label: "Số Lượng Cần Xuất (Tấn)",
            value: "soluongcanxuat",
            type: "number",
            styles: {
              textAlign: "center",
            },
          },
        ],
      },
    },
    {
      name: "Ghi Chú",
      alias: "ghiChuLenhXuatHangLXH",
      type: "text",
    },
  ]);

  const _token = localStorage.getItem("_token");

  useEffect(() => {
    const tableId = 22577;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          betChar,
                          textarea,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name
                      );
                      if (field) {
                        return {
                          ...field,
                          name: content,
                          alias: variable_name,
                          required,
                          betChar,
                          type: textarea ? "textarea" : field.type,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);

                  setInputFields(mappedFields);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data) {
          setDefaultValues(data.display_fields);
          data.display_fields.forEach((item) => {
            if (inputFields.some(({ alias }) => item.fomular_alias === alias)) {
              const { default_value, fomular_alias } = item;
              if (default_value) {
                // setValue(fomular_alias, item.default_value);
              }
            }
          });
        }
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        for (const item of inputFields) {
          if (item.type === "input-select") {
            const table_id = item?.table_id;
            const foreignResponse = await ForeignData_API.get(proxy(), _token, {
              table_id,
            });
            const { data: foreignData = [] } = foreignResponse;

            if (foreignData.length) {
              const mapped = foreignData.reduce((acc, curr) => {
                const find = item?.displayFields?.map((field) => curr[field]);

                if (find.some((field) => field)) {
                  acc.push({
                    label: find.join("|"),
                    value: find?.[0],
                  });
                }
                return acc;
              }, []);
              setOptions(mapped);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [inputFields, _token]);

  const onSubmit = async (data) => {
    const trimmedData = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    const mappedData = {
      data: {
        ...trimmedData,
        details: dataTable || null,
      },
      default_field_value: defaultValues,
      table: isTables,
    };

    const res = await submitForm({
      url: `/api/LXH`,
      data: mappedData,
      proxy,
      lang,
      inputFields,
    });

    if (res) {
      inputFields.forEach((item) => {
        const { alias, readOnly } = item;
        if (!readOnly) {
          reset({
            [alias]: "",
          });
        }
      });
      setSelectedValues({});
      setDataTables([]);
    }
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Lệnh Xuất hàng
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["create"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12">
                    <div
                      style={{
                        height: "70vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                        {inputFields.map((field, index) => {
                          const { required, name, alias, col, style } = field;
                          return (
                            <>
                              <div
                                className={` ${
                                  col ? col : `col-sm-8  offset-sm-2`
                                } mb-3`}
                                style={style}
                              >
                                <label class="form-label">
                                  {name}
                                  {required && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>
                                <RenderInputsLXH
                                  control={control}
                                  register={register}
                                  selectedValues={selectedValues}
                                  setSelectedValues={setSelectedValues}
                                  field={field}
                                  options={options}
                                  setValue={setValue}
                                  getValues={getValues}
                                  refresh={resfresh}
                                  setDataTables={setDataTables}
                                  isCreate={true}
                                  dataTable={dataTable}
                                />
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-sm-7 offset-sm-3 p-0">
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success mr-2"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => setSubmit(true)}
                        >
                          Thêm mới
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => navigate(-1)}
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
